import BASE_URL from "../config";

const json = async (response) => {
  const result = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, ...result };
};

const authHeaders = (token, extra = {}) => ({ ...extra, Authorization: `Bearer ${token}` });

// Short cache: the bar is on every page, but an admin edit should appear fast.
const TTL_MS = 60 * 1000;
let cached = null;
let cachedAt = 0;
let inFlight = null;

export const getAnnouncements = async () => {
  if (cached && Date.now() - cachedAt < TTL_MS) return cached;
  if (inFlight) return inFlight;

  inFlight = (async () => {
    try {
      const result = await json(await fetch(`${BASE_URL}/announcements`));
      cached = result.ok && result.success ? result.data || [] : [];
    } catch {
      cached = []; // backend unreachable: no bar rather than a broken page
    } finally {
      cachedAt = Date.now();
      inFlight = null;
    }
    return cached;
  })();

  return inFlight;
};

/* ----------------------------------------------------------------- admin */

export const adminGetAnnouncements = async (token) =>
  json(await fetch(`${BASE_URL}/announcements/admin`, { headers: authHeaders(token) }));

export const adminSaveAnnouncement = async (id, payload, token) =>
  json(
    await fetch(`${BASE_URL}/announcements/admin${id ? `/${id}` : ""}`, {
      method: id ? "PUT" : "POST",
      headers: authHeaders(token, { "Content-Type": "application/json" }),
      body: JSON.stringify(payload),
    })
  );

export const adminDeleteAnnouncement = async (id, token) =>
  json(
    await fetch(`${BASE_URL}/announcements/admin/${id}`, {
      method: "DELETE",
      headers: authHeaders(token),
    })
  );
